import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5723f0f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-font-size mb--20" }, "История", -1))
const _hoisted_2 = {
  key: 0,
  class: "container center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "none-Mobile" }
const _hoisted_5 = { class: "mobile-table" }
const _hoisted_6 = { class: "request-history__mobile-table-row mobile-table__row" }
const _hoisted_7 = {
  key: 0,
  class: "center"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "request-history__modal" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium mr--5" }, "Дата/Время:", -1))
const _hoisted_11 = { class: "mt--10" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium mr--5" }, "Тема:", -1))
const _hoisted_13 = { class: "mt--10" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium mr--5" }, "Сообщение:", -1))

import { computed, onMounted, ref, Ref, watch } from 'vue';
import { HeaderType, ItemType } from '@/types/TableTypes';
import { useUserStore } from '@/store/modules/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestHistory',
  setup(__props) {

const isLoading = ref(false);
const modalInfo: Ref<{ show: boolean; item?: ItemType }> = ref({ show: false });
const prepareValues: Ref<ItemType[]> = ref([]);
const values = computed((): ItemType[] => {
  return useUserStore().supportList;
});

const showInfoModal = async (item: ItemType) => {
  modalInfo.value = { show: true, item: item };
};
const headers = computed((): HeaderType[] => {
  return [
    {
      text: 'Дата/Время',
      value: 'date',
      align: 'left',
    },
    {
      text: 'Тема',
      value: 'theme',
      align: 'left',
    },
    {
      text: 'Сообщение',
      value: 'comment',
      align: 'left',
    },
    {
      text: '',
      value: 'view',
      align: 'center',
      click: showInfoModal,
    },
  ];
});

onMounted(async () => {
  isLoading.value = true;
  await useUserStore().getSupportList();
  isLoading.value = false;
});

watch(
  () => values.value,
  () => {
    prepareValues.value = values.value;
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_table = _resolveComponent("base-table")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_pagination_group = _resolveComponent("base-pagination-group")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_card, {
      class: "request-history",
      "full-width-mobile": ""
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_base_spinner, {
                size: 50,
                color: "#009D3E"
              })
            ]))
          : (prepareValues.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_base_table, {
                    headers: headers.value,
                    items: prepareValues.value,
                    style: 'simple'
                  }, null, 8, ["headers", "items"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepareValues.value, (value) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.value, (header) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: _normalizeStyle({ gridArea: header.value }),
                          class: "request-history__mobile-table-text"
                        }, [
                          (value[header.value]?.icon !== undefined)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createVNode(_component_base_icon, {
                                  name: value[header.value]?.icon,
                                  clickable: "",
                                  color: "#888298",
                                  height: "18",
                                  width: "21",
                                  onClick: ($event: any) => (header.click ? header.click(value) : () => {})
                                }, null, 8, ["name", "onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass({ medium: header.value === 'theme' })
                          }, _toDisplayString(value[header.value].value), 3)
                        ], 4))
                      }), 256))
                    ]))
                  }), 256))
                ]),
                _createVNode(_component_base_pagination_group, {
                  modelValue: prepareValues.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((prepareValues).value = $event)),
                  "max-for-visible": values.value.length,
                  "show-btn": false,
                  values: values.value,
                  class: "mt--20"
                }, null, 8, ["modelValue", "max-for-visible", "values"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, "Обращений нет"))
      ]),
      _: 1
    }),
    _createVNode(_component_base_modal, {
      "show-modal": modalInfo.value.show,
      "close-outside": "",
      "hide-title": "",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (modalInfo.value.show = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(modalInfo.value.item['date'].value), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", null, _toDisplayString(modalInfo.value.item['theme'].value), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", null, _toDisplayString(modalInfo.value.item['comment'].value), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show-modal"])
  ]))
}
}

})